import React from "react";
import { Link } from "react-router-dom";

import ContactIcons from "../Contact/ContactIcons";

const PUBLIC_URL = import.meta.env.BASE_URL || ""; // Vite base URL

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src="/images/me.webp" alt="" />
      </Link>
      <header>
        <h2>Batchema E. Sombie</h2>
        <p>
          <a href="mailto:batchema@mailmytaxes.com">Email me</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Co-founder &amp; CTO at{" "}
        <a href="https://liivai.com" target="_blank" rel="noreferrer">
          Liiv AI
        </a>
        . Founder of{" "}
        <a href="https://www.mailmytaxes.com" target="_blank" rel="noreferrer">
          MailMyTaxes.com
        </a>
        . Previously Tech Lead at Credit Karma.
      </p>
      <ul className="actions">
        <li>
          {window.location.pathname.includes("/resume") ? (
            <Link to="/about" className="button">
              About Me
            </Link>
          ) : (
            <Link to="/resume" className="button">
              Resume
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Batchema Sombie <Link to="/">batchema.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
